module.exports = __webpack_public_path__ + "img/max-file-sync--zip.2272b8f6.svg";